import React from "react";
import "../../styles/howitworks.scss";

function NewHowItWorks(props) {
  const primary = props?.partner?.primary_color || "#1B3964";   // Blue
  const secondary = props?.partner?.secondary_color || "#83C547"; // Green

  const steps = [
    {
      id: 1,
      title: "Apply for a Guaranteed Backup Agreement",
      points: [
        "Submit a quick application",
        "Calque will reach out within 1–2 business days to gather more information",
        "If the home qualifies, Calque will issue an agreed upon Guaranteed Backup Agreement on your current home",
      ],
    },
    {
      id: 2,
      title: "Submit Stronger Offers — and Win",
      points: [
        "Calque’s Guaranteed Backup Agreement removes the home sale contingency to strengthen your bids",
        "Work with your lender to finalize the loan approval process",
      ],
    },
    {
      id: 3,
      title: "Move In and List Your Previous Home",
      points: [
        "Avoid the stress of double moves, temporary housing, and storage — once you’ve closed on your new home, you can move in right away!",
        "Work with your real estate agent to stage, show, and sell an empty home all from the comfort of your new one",
      ],
    },
    {
      id: 4,
      title: "Sell and Close Seamlessly",
      points: [
        "In the unlikely case you are unable to sell the home within 180 days, Calque will purchase it per our Guaranteed Backup Agreement",
      ],
    },
  ];

  return (
    <div className="hiw-wrapper" id="trade">

      <h2 className="hiw-title">
        <span style={{ color: secondary }}>How It Works</span>{" "}
        <span>in 4 Simple Steps</span>
      </h2>

      <div className="hiw-content-container">
        {steps.map((step, i) => (
          <div className="hiw-row" key={step.id}>
            
            {/* LEFT SIDE NUMBER + LINE */}
            <div className="hiw-left-column">
              <div className="hiw-number" style={{ backgroundColor: primary }}>
                {step.id}
              </div>

              {i !== steps.length - 1 && (
                <div
                  className="hiw-vertical-line"
                  style={{ backgroundColor: secondary }}
                />
              )}
            </div>

            {/* RIGHT SIDE CONTENT */}
            <div className="hiw-text-column">
              <h3 className="hiw-step-title" style={{ color: primary }}>
                {step.title}
              </h3>

              <ul className="hiw-bullets">
                {step.points.map((p, index) => (
                  <li key={index}> {p}</li>
                ))}
              </ul>
            </div>

          </div>
        ))}

        <p className="hiw-footer-note">
          We've got your back. If Calque purchases the house, and we sell it for
          more than our offer, Calque will refund the net profit after our
          expenses have been covered, including but not limited to the purchase
          price, commissions, interest, taxes, title and other applicable fees.
        </p>

      </div>
    </div>
  );
}

export default NewHowItWorks;
